import "./PropVRaiRedesign.module.css";
import Header from "@/reusable_sections/Header";
import CinematicVision from "./sections/CinematicVision";
import TrustedByIndustryLeaders from "./sections/TrustedByIndustryLeaders";
import SectorExpertise from "./sections/SectorExpertise";
import DigitalAndSocial from "./sections/DigitalAndSocial";
import Tables from "./sections/Tables";
import RealTimeMonitoring from "./sections/RealTimeMonitoring";
import TheImpactWeMeasure from "./sections/TheImpactWeMeasure";
import ProductBenefits from "./sections/ProductBenefits";
import TheAiShowcase from "./sections/TheAiShowcase";
import ContactTheLndryCo from "./sections/ContactTheLndryCo";
import BeginYourTransformation from "./sections/BeginYourTransformation";
import JurisdictionsCoverage from "./sections/JurisdictionsCoverage";
import SiteFooter from "@/reusable_sections/Footer";
export default function PropVRaiRedesignPage() {
  return <div>
      <Header />
      <CinematicVision />
      <TrustedByIndustryLeaders />
      <SectorExpertise />
      <DigitalAndSocial />
      <Tables />
      <RealTimeMonitoring />
      <TheImpactWeMeasure />
      <ProductBenefits />
      <TheAiShowcase />
      <ContactTheLndryCo />
      <BeginYourTransformation />
      <JurisdictionsCoverage />
      <SiteFooter />
    </div>;
}